export const LOADING_START = "LOADING_START";
export const LOADING_END = "LOADING_END";
export const DISPLAY_MESSAGE = "DISPLAY_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
export const SET_MESSAGE_CLASS = "SET_MESSAGE_CLASS";
export const ADD_TO_DISMISS_MESSAGE = "ADD_TO_DISMISS_MESSAGE";
export const CLEAR_TO_DISMISS_MESSAGES = "CLEAR_TO_DISMISS_MESSAGES";
export const DISPLAY_DIALOG = "DISPLAY_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const AS_COMPANY = "AS_COMPANY";
export const SET_LEFT_NAV_COLLAPSED = "SET_LEFT_NAV_COLLAPSED";
export const SET_FULL_SCREEN_DIALOG_OPEN = "SET_FULL_SCREEN_DIALOG_OPEN";
export const SET_FILTER_DRAWER_OPEN = "SET_FILTER_DRAWER_OPEN";
